
import HomePage from "./features/features";
import NavBar from "./components/layout/header";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import Login from "./features/features";
import Footer from "./components/layout/footer";
import Header from "./components/layout/header";
import Loader from "@components/home-page/shared-components/loader/loader";
import { useAppSelector } from "@store/hooks";
import { ThemeProvider, ToastProvider } from "@veneer/core";
import "./styles/main.scss"
import "./App.css";
import ScrollToTop from "@components/shared-components/scroll-top-top/scroll-top-top";
import TitleUpdater from "@components/shared-components/title-updater/title-updater";

function App() {
  const basename: any = (window as any).langPath? "/" + (window as any).langPath: "/en-US";
  localStorage.setItem("app_lang", basename);
  const isLoading = useAppSelector((state) => state.loading.isLoading);
  document.documentElement.lang = (window as any).langPath? (window as any).langPath: "en-US";

  return (
    <>
      <ThemeProvider density="high" mode="light" shape="round">
        {isLoading && (
          <div className="loader-overlay">
            <div className="loader-css">
              <Loader />
            </div>
          </div>
        )}
        <ToastProvider>
          <Router
             basename={
              (window as any).langPath
                ? "/" + (window as any).langPath
                : "/en-US"
            }
          >
        <div className="app-container">
        <ScrollToTop />
        <TitleUpdater />
          <Header />
          <NavBar />
          <main className="content">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/*" element={<Login />} />
            </Routes>
          </main>
          <Footer />
        </div>


          </Router>
        </ToastProvider>
      </ThemeProvider>
    </>
  );
}

export default App;
